import { render, staticRenderFns } from "./BookingsForCourt.vue?vue&type=template&id=8cb047dc&scoped=true&"
import script from "./BookingsForCourt.vue?vue&type=script&lang=js&"
export * from "./BookingsForCourt.vue?vue&type=script&lang=js&"
import style0 from "./BookingsForCourt.vue?vue&type=style&index=0&id=8cb047dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb047dc",
  null
  
)

export default component.exports